import { useAppDispatch } from "../hooks/useAppDispatch";
import { useLayoutState } from "../hooks/useLayoutState";
import clsx from "clsx";
import styles from "./Header.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../state/reducers/rootReducer";
import { ActionList, ActionMenu, Button } from "@primer/react";
import UserAvatar from "../components-ui/user-avatar";
import { rootActions } from "../state/actions/rootActions";
import { useNavigate } from "react-router-dom";
import { HomeIcon, KeyIcon, SignOutIcon } from "@primer/octicons-react";
import { useEffect, useMemo, useState } from "react";
import { appConst } from "../AppConst";
import { useAuth } from "oidc-react";

const Header= () => {
    const { hoc_ky, nam_hoc } = useLayoutState();
    const defaultCode = "aof";
    const [code, setCode] = useState<string>(defaultCode);
    const rawCode = appConst.schoolCode?.toLowerCase() ?? defaultCode;
  
        const dispatch = useAppDispatch();
     const { user } = useSelector((x: RootState) => x.auth)
        const navigate = useNavigate();
        const character_name = useMemo(() => {
            const texts = user?.full_name.split(' ') ?? ["N"];
            return texts[texts.length - 1].split('')[0];
        }, [user?.full_name]);

    const  handleLogout = async () => {
         
        dispatch(rootActions.auth.LOGOUT_START({
            access_token: "",
            refresh_token: ""
        }));
         navigate('../../signout-oidc');
    };

    const handleChangerPassword = async () => {
        window.location.href = appConst.APP_URL_PAGE_MAIN + '/ResetPassword.html?token=' + localStorage.access_token;
    };



      useEffect(() => {
        const img = new Image();
        const testUrl = `${process.env.PUBLIC_URL}/imageStyle/${rawCode}/bannerLeft.png`;

        img.onload = () => setCode(rawCode);      // file tồn tại → dùng code thật
        img.onerror = () => setCode(defaultCode); // file không tồn tại → dùng aof

        img.src = testUrl;
      }, [rawCode]);

const bannerLeft  = `${process.env.PUBLIC_URL}/imageStyle/${code}/bannerLeft.png`;
const bannerRight = `${process.env.PUBLIC_URL}/imageStyle/${code}/banner.png`;
        return (
        <section id={clsx(styles.header)} style={{ height: `${appConst.headerHeight}px` , background: `url(${bannerRight}) right center no-repeat` }}>
            <div className={clsx(styles.left)} 
            style={{ background: `url(${bannerLeft}) right center no-repeat` }}>
                <p>{appConst.authName}</p>
                <p>{appConst.authDescription} <span className={clsx(styles.Company)}>{appConst.authCompany}</span> </p> 
            </div>
            <div className={clsx(styles.mid)}>
                <a href="/" className={clsx(styles.logo)}>
                    <img src={appConst.appURLLogo} alt="Logo" />
                </a>
                <div className={clsx(styles.nameProduct)}>
                  <p>{appConst.schoolName}</p>
                  <p>{appConst.appicationName}</p>
                </div>
            </div>
            <div className={clsx(styles.right)}>
                {/* <div className={clsx(styles.searchForm)}></div> */}
                

        <div className={clsx(styles.userInfo)}>
          <div className={clsx(styles.top)}>
            <div className={clsx(styles.imageUser)}>
              <img
                alt="avatar"
                src={`../../../../images/${character_name ?? "N"}.png`}
                width={30}
                height={30}
                style={{
                  borderRadius: "50%",
                  border: "2px solid #fff",
                }}
              />
            </div>
            <p className={clsx(styles.userName)}>{user?.full_name}</p>
          </div>
          <div className={clsx(styles.mnSub)}>
            <ul>
              {/* <li>
                <a href="">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 7.75C6.5375 7.75 5.71354 7.40729 5.02813 6.72188C4.34271 6.03646 4 5.2125 4 4.25C4 3.2875 4.34271 2.46354 5.02813 1.77813C5.71354 1.09271 6.5375 0.75 7.5 0.75C8.4625 0.75 9.28646 1.09271 9.97188 1.77813C10.6573 2.46354 11 3.2875 11 4.25C11 5.2125 10.6573 6.03646 9.97188 6.72188C9.28646 7.40729 8.4625 7.75 7.5 7.75ZM0.5 14.75V12.3C0.5 11.8042 0.627604 11.3484 0.882812 10.9328C1.13802 10.5172 1.47708 10.2 1.9 9.98125C2.80417 9.52917 3.72292 9.1901 4.65625 8.96406C5.58958 8.73802 6.5375 8.625 7.5 8.625C8.4625 8.625 9.41042 8.73802 10.3438 8.96406C11.2771 9.1901 12.1958 9.52917 13.1 9.98125C13.5229 10.2 13.862 10.5172 14.1172 10.9328C14.3724 11.3484 14.5 11.8042 14.5 12.3V14.75H0.5ZM2.25 13H12.75V12.3C12.75 12.1396 12.7099 11.9937 12.6297 11.8625C12.5495 11.7312 12.4438 11.6292 12.3125 11.5563C11.525 11.1625 10.7302 10.8672 9.92813 10.6703C9.12604 10.4734 8.31667 10.375 7.5 10.375C6.68333 10.375 5.87396 10.4734 5.07188 10.6703C4.26979 10.8672 3.475 11.1625 2.6875 11.5563C2.55625 11.6292 2.45052 11.7312 2.37031 11.8625C2.2901 11.9937 2.25 12.1396 2.25 12.3V13ZM7.5 6C7.98125 6 8.39323 5.82865 8.73594 5.48594C9.07865 5.14323 9.25 4.73125 9.25 4.25C9.25 3.76875 9.07865 3.35677 8.73594 3.01406C8.39323 2.67135 7.98125 2.5 7.5 2.5C7.01875 2.5 6.60677 2.67135 6.26406 3.01406C5.92135 3.35677 5.75 3.76875 5.75 4.25C5.75 4.73125 5.92135 5.14323 6.26406 5.48594C6.60677 5.82865 7.01875 6 7.5 6Z"
                      fill="#333333"
                    />
                  </svg>
                  <span>Thông tin người dùng</span>
                </a>
              </li>
              <li>
                <a href="">
                  <svg
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.77319 9.63178H7.22704C7.34819 9.63178 7.45252 9.58748 7.54002 9.49887C7.62752 9.41026 7.6578 9.31279 7.63088 9.20646L7.24723 7.3457C7.51646 7.22756 7.72848 7.05625 7.88329 6.83178C8.03809 6.60731 8.1155 6.35921 8.1155 6.08748C8.1155 5.6976 7.95732 5.36385 7.64098 5.08621C7.32463 4.80857 6.94434 4.66975 6.50011 4.66975C6.05588 4.66975 5.67559 4.80857 5.35925 5.08621C5.0429 5.36385 4.88473 5.6976 4.88473 6.08748C4.88473 6.35921 4.96213 6.60731 5.11694 6.83178C5.27175 7.05625 5.48377 7.22756 5.753 7.3457L5.36934 9.20646C5.34242 9.31279 5.37271 9.41026 5.46021 9.49887C5.54771 9.58748 5.65204 9.63178 5.77319 9.63178ZM6.50011 14.5229C6.40588 14.5229 6.31838 14.517 6.23761 14.5052C6.15684 14.4934 6.07607 14.4757 5.9953 14.452C4.178 13.9204 2.73088 12.9368 1.65396 11.5014C0.577036 10.066 0.0385742 8.52123 0.0385742 6.86722V3.51786C0.0385742 3.2225 0.13617 2.95667 0.331363 2.72039C0.526555 2.4841 0.778959 2.31279 1.08857 2.20646L5.93473 0.611526C6.12319 0.552455 6.31165 0.522919 6.50011 0.522919C6.68857 0.522919 6.87704 0.552455 7.0655 0.611526L11.9117 2.20646C12.2213 2.31279 12.4737 2.4841 12.6689 2.72039C12.8641 2.95667 12.9617 3.2225 12.9617 3.51786V6.86722C12.9617 8.52123 12.4232 10.066 11.3463 11.5014C10.2693 12.9368 8.82223 13.9204 7.00492 14.452C6.92415 14.4757 6.84338 14.4934 6.76261 14.5052C6.68184 14.517 6.59434 14.5229 6.50011 14.5229ZM6.50011 13.1052C7.90011 12.7153 9.0578 11.9356 9.97319 10.766C10.8886 9.59634 11.3463 8.29676 11.3463 6.86722V3.51786L6.50011 1.92292L1.65396 3.51786V6.86722C1.65396 8.29676 2.11165 9.59634 3.02704 10.766C3.94242 11.9356 5.10011 12.7153 6.50011 13.1052Z"
                      fill="#333333"
                    />
                  </svg>
                  <span>Đổi mật khẩu</span>
                </a>
              </li> */}
              <li>
                {appConst.APP_URL_PAGE_MAIN && 
                <a href='#' onClick={handleChangerPassword}>
                
                  <KeyIcon />
               
                  <span>Đổi mật khẩu</span>
                </a>}
                
                <a href={appConst.OIDC_UNIT === 'vnpt' ? 'javascript://' :  "javascript://"} onClick={handleLogout}>
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.3999 14.25C1.9874 14.25 1.63428 14.1031 1.34053 13.8094C1.04678 13.5156 0.899902 13.1625 0.899902 12.75V2.25C0.899902 1.8375 1.04678 1.48438 1.34053 1.19063C1.63428 0.896875 1.9874 0.75 2.3999 0.75H6.8999C7.1124 0.75 7.29053 0.821875 7.43428 0.965625C7.57803 1.10938 7.6499 1.2875 7.6499 1.5C7.6499 1.7125 7.57803 1.89062 7.43428 2.03438C7.29053 2.17813 7.1124 2.25 6.8999 2.25H2.3999V12.75H6.8999C7.1124 12.75 7.29053 12.8219 7.43428 12.9656C7.57803 13.1094 7.6499 13.2875 7.6499 13.5C7.6499 13.7125 7.57803 13.8906 7.43428 14.0344C7.29053 14.1781 7.1124 14.25 6.8999 14.25H2.3999ZM11.5312 8.25H6.1499C5.9374 8.25 5.75928 8.17813 5.61553 8.03438C5.47178 7.89063 5.3999 7.7125 5.3999 7.5C5.3999 7.2875 5.47178 7.10938 5.61553 6.96563C5.75928 6.82188 5.9374 6.75 6.1499 6.75H11.5312L10.1249 5.34375C9.9874 5.20625 9.91865 5.0375 9.91865 4.8375C9.91865 4.6375 9.9874 4.4625 10.1249 4.3125C10.2624 4.1625 10.4374 4.08438 10.6499 4.07813C10.8624 4.07188 11.0437 4.14375 11.1937 4.29375L13.8749 6.975C14.0249 7.125 14.0999 7.3 14.0999 7.5C14.0999 7.7 14.0249 7.875 13.8749 8.025L11.1937 10.7063C11.0437 10.8563 10.8655 10.9281 10.6593 10.9219C10.453 10.9156 10.2749 10.8375 10.1249 10.6875C9.9874 10.5375 9.92178 10.3594 9.92803 10.1531C9.93428 9.94688 10.0062 9.775 10.1437 9.6375L11.5312 8.25Z"
                      fill="#333333"
                    />
                  </svg>
                  <span>Đăng xuất</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
            </div>
        </section>
    );
};

export default Header;